"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getDefaultFileProvider_1 = require("./actions/helpers/getDefaultFileProvider");
exports.getDefaultFileProvider = getDefaultFileProvider_1.default;
var FilePickerAction_1 = require("./store/schema/FilePickerAction");
exports.FilePickerAction = FilePickerAction_1.default;
var FilePickerResult_1 = require("./types/FilePickerResult");
exports.SelectedFilesSource = FilePickerResult_1.SelectedFilesSource;
var FilePickerViewSwitcher_1 = require("./types/FilePickerViewSwitcher");
exports.FilePickerViewType = FilePickerViewSwitcher_1.FilePickerViewType;
var lazyAddFileProviderHelper_1 = require("./utils/lazyAddFileProviderHelper");
var owa_bundling_1 = require("owa-bundling");
var owa_fileprovider_store_1 = require("owa-fileprovider-store");
exports.FileSelectionFilter = owa_fileprovider_store_1.FileSelectionFilter;
var FileProviderItemViewState_1 = require("./store/schema/FileProviderItemViewState");
exports.FileProviderItemType = FileProviderItemViewState_1.FileProviderItemType;
var filePickerConstants_1 = require("./utils/filePickerConstants");
exports.FacebookDataProviderItemType = filePickerConstants_1.FacebookDataProviderItemType;
exports.FacebookProviderScopeType = filePickerConstants_1.FacebookProviderScopeType;
exports.SizeLimitInKbToSuggestSharing = filePickerConstants_1.SizeLimitInKbToSuggestSharing;
/* This package SHOULD contain minimal attachment related logic. It should NOT take any dependencies on the attachment package.
   It is supposed to be self contained and possibly reusable outside OWA for picking files from different providers */
owa_bundling_1.preloadScriptChunk('FilePicker');
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return System.import(/* webpackChunkName: "FilePicker" */ './lazyIndex');
});
lazyAddFileProviderHelper_1.initAddFileProvider();
// Delay loaded action
exports.lazyRemoveFileProvider = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.removeFileProvider; });
// Delay loaded imports
exports.lazyGetGDriveFileProviderItems = new owa_bundling_1.LazyImport(lazyModule, function (m) { return m.getGDriveFileProviderItems; });
exports.lazyGetFileProviderItemsServiceCall = new owa_bundling_1.LazyImport(lazyModule, function (m) { return m.getFileProviderItemsServiceCall; });
exports.lazyGetFileProviderItems = new owa_bundling_1.LazyImport(lazyModule, function (m) { return m.getFileProviderItems; });
exports.lazyCreateFileProviderItemsViewState = new owa_bundling_1.LazyImport(lazyModule, function (m) { return m.createFileProviderItemsViewState; });
exports.lazyPreloadFilePicker = new owa_bundling_1.LazyImport(lazyModule, function (m) { return m.preloadFilePicker; });
exports.lazyAddAndSelectFileProvider = new owa_bundling_1.LazyImport(lazyModule, function (m) { return m.addAndSelectFileProvider; });
exports.lazyGetUserPreferredFilePickerAction = new owa_bundling_1.LazyImport(lazyModule, function (m) { return m.getUserPreferredFilePickerAction; });
var filePickerStore_1 = require("./store/filePickerStore");
exports.filePickerStore = filePickerStore_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/attachments/owa-filepicker-store/lib/index.js
// module id = 1590
// module chunks = 2 3 43 106 107